/**
 * Formatter functions for data display
 */

// Formats date from ISO string to DD.MM.YYYY
export const formatDate = (isoDate) => {
    if (!isoDate) return '';
    
    const date = new Date(isoDate);
    return date.toLocaleDateString('cs-CZ', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };
  
  // Formats date with time DD.MM.YYYY HH:MM
  export const formatDateTime = (isoDate) => {
    if (!isoDate) return '';
    
    const date = new Date(isoDate);
    return date.toLocaleDateString('cs-CZ', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  
  // Formats price with currency
  export const formatPrice = (price, currency = 'Kč') => {
    return `${new Intl.NumberFormat('cs-CZ').format(price)} ${currency}`;
  };
  
  // Formats phone number (adds spaces to Czech format)
  export const formatPhone = (phone) => {
    if (!phone) return '';
    
    // Remove all non-digits
    const cleaned = phone.replace(/\D/g, '');
    
    // Check if international format (Czech)
    if (cleaned.startsWith('420') && cleaned.length > 9) {
      const countryCode = '+420';
      const restOfNumber = cleaned.substring(3);
      return `${countryCode} ${restOfNumber.substring(0, 3)} ${restOfNumber.substring(3, 6)} ${restOfNumber.substring(6, 9)}`;
    }
    
    // Format 9-digit local number
    if (cleaned.length === 9) {
      return `${cleaned.substring(0, 3)} ${cleaned.substring(3, 6)} ${cleaned.substring(6, 9)}`;
    }
    
    return phone; // Return original if doesn't match expected formats
  };
  
  // Truncates text with ellipsis
  export const truncateText = (text, maxLength = 100) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };
  
  // Formats file size (bytes to KB/MB)
  export const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    
    const k = 5024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };
  
  // Converts string to slug (URL-friendly string)
  export const slugify = (text) => {
    return text
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]+/g, '')
      .replace(/--+/g, '-');
  };
  
  // Capitalizes first letter of a string
  export const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
  };